/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */

import { MEDIA_LIMITS } from '../constants/mediaLimitsByPlatform';

/**
 * Validate a media file against one or more platforms.
 * Supports string or array of platforms.
 *
 * @param {File} file - File to validate
 * @param {string|string[]} platforms - Ej: 'whatsapp' o ['whatsapp', 'messenger']
 * @returns {{ valid: boolean, error?: string, type?: string, checkedPlatforms: string[] }}
 */
// eslint-disable-next-line import/prefer-default-export
export const validateMediaByPlatforms = (file, platforms = []) => {
  if (!file) {
    return { valid: false, error: 'No se ha seleccionado ningún archivo.' };
  }
  const platformList = Array.isArray(platforms) ? platforms : [platforms];

  const mimeType = file.type.toLowerCase();

  let fileType;

  if (mimeType.startsWith('image/')) {
    fileType = 'image';
  } else if (mimeType.startsWith('video/')) {
    fileType = 'video';
  } else if (mimeType.startsWith('audio/')) {
    fileType = 'audio';
  } else {
    fileType = 'document';
  }

  const sizeMB = file.size / (1024 * 1024);

  let minLimit = Infinity;
  const unsupported = [];

  for (const platform of platformList) {
    const limits = MEDIA_LIMITS[platform.toLowerCase()];
    if (!limits) {
      unsupported.push(platform);
      continue;
    }

    const typeLimits = limits[fileType];
    if (!typeLimits || !typeLimits.types.includes(mimeType)) {
      unsupported.push(platform);
      continue;
    }

    minLimit = Math.min(minLimit, typeLimits.maxMB);
  }

  if (unsupported.length > 0) {
    return {
      valid: false,
      error: `Este archivo no es soportado por: ${unsupported.join(', ')}`,
      checkedPlatforms: platformList
    };
  }

  if (sizeMB > minLimit) {
    return {
      valid: false,
      error: `El archivo excede el límite de (${minLimit} MB) para ${fileType}`,
      checkedPlatforms: platformList,
      type: fileType
    };
  }

  return {
    valid: true,
    checkedPlatforms: platformList,
    type: fileType
  };
};
